module.exports = __webpack_public_path__ + "static/img/NI.bd240e8e.jpg";